import { TRUST_ITEMS, CLIENTS } from "../data/content";
import { Reveal } from "./Reveal";

const WORDMARK_STYLES = [
  "font-display font-semibold tracking-tight",
  "font-mono font-medium tracking-[0.14em]",
  "font-display font-medium italic",
  "font-body font-semibold tracking-tight",
  "font-mono font-bold",
  "font-display font-medium tracking-wide",
  "font-body font-medium tracking-[0.08em]",
  "font-display font-semibold",
  "font-mono font-medium tracking-[0.2em]",
];

export const TrustMarquee = () => {
  const items = [...TRUST_ITEMS, ...TRUST_ITEMS, ...TRUST_ITEMS];
  return (
    <div data-testid="trust-marquee" className="marquee-track relative overflow-hidden py-3 select-none">
      <span className="texture-grain absolute inset-0" aria-hidden="true" />
      <span className="absolute inset-0 bg-ember/25 mix-blend-multiply" aria-hidden="true" />
      <div className="marquee-inner relative flex w-max animate-marquee-slow">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-mono font-medium text-[11px] sm:text-xs tracking-[0.24em] text-white px-8">{item}</span>
            <span className="w-1.5 h-1.5 rotate-45 bg-white/70 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const LogoMarquee = () => {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="logo-marquee-section" className="pt-16 sm:pt-20 pb-16 sm:pb-20 overflow-hidden">
      <div className="px-6 sm:px-10 lg:px-16 max-w-[1700px] mx-auto mb-12">
        <Reveal>
          <p className="font-mono text-[10px] sm:text-xs tracking-[0.28em] text-ember mb-5">TRUSTED ACROSS CALIFORNIA</p>
          <h2 className="font-display font-medium tracking-[-0.02em] text-2xl sm:text-4xl lg:text-5xl text-charcoal max-w-3xl leading-[1.08]">
            Trusted by businesses &amp; organizations <span className="font-light">across California.</span>
          </h2>
          <p className="mt-4 text-sm sm:text-base text-charcoal/55 max-w-xl">
            A selection of organizations, properties and projects served by Nagel Landscaping.
          </p>
        </Reveal>
      </div>
      <div className="marquee-track overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
        <div className="marquee-inner flex w-max animate-marquee-slower items-center">
          {items.map((name, i) => (
            <span
              key={i}
              data-testid={i < CLIENTS.length ? `client-logo-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}
              className={`whitespace-nowrap px-10 sm:px-14 text-lg sm:text-2xl text-charcoal/30 hover:text-charcoal/90 transition-colors duration-500 cursor-default ${WORDMARK_STYLES[i % WORDMARK_STYLES.length]}`}
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
